import Pararax from './pararax';
import ScrollAnimation from './scrollanimation';
import catalogAnimation from './cataloganimation';
import kitchenitemsAnimation from './kitchenitemsanimation';
import awardsAnimation from './awardsanimation';
import newcolorAnimation from './newcoloranimation';
import miniAnimation from './minianimation';

let pararax;
let scrollAnimation;

export default class smoothScrollManager{
    constructor(param,effect,pageID){

        pararax = new Pararax();
        if((pageID === "mission"
            || pageID === "made_in_japan"
            || pageID === "made_in_japan01"
            || pageID === "made_in_japan02"
            || pageID === "made_in_japan03"
            || pageID === "made_in_japan04"
            || pageID === "made_in_japan05"
            || pageID === "special_interview"
            || pageID === "ownervoice01"
            || pageID === "ownervoice02"
            || pageID === "ownervoice03"
            ) && param.userAgent === "pc"){
            scrollAnimation = new catalogAnimation(param);
        }else if(pageID === "magnettrivet" || pageID === "hk_and_ph" || pageID === "apron_and_cloth" && param.userAgent === "pc"){
            scrollAnimation = new kitchenitemsAnimation(param);
        }else if(pageID === "awards" && param.userAgent !== "sp"){
            scrollAnimation = new awardsAnimation(param);
        }else if(pageID === "new_color"){
            scrollAnimation = new newcolorAnimation(param);
        }else if(pageID === "mini"){
            scrollAnimation = new miniAnimation(param);
        }else if(param.userAgent === "pc"){
            scrollAnimation = new ScrollAnimation(effect);
        }

        this.w = window.innerWidth;
        this.h = window.innerHeight;

        this.$root = document.getElementById("l-root");
        this.$rootLoad = document.getElementById("l-root-load");
        this.$pararax = document.getElementsByClassName("js__psc");

        this.inc = 0;
        this.nowInc = 0;
        this.prevInc = 0;
        this.sighedDiffInc = 0;
        this.diffInc = 0;
        this.disallowedInc = 0;

        this.inertia = (Useragnt.mobile||Useragnt.tablet||param.browserType === 'IE'||param.browserType === 'safari')?false:true; /* 慣性スクロールを有効にするか */

        this.bodyMatrix;
        this.pararaxMatrix;

        /* 状態監視用のフラグ */
        this.status = {
            controll : false, /* ページャーなどで操作しているか */
            comp     : true, /* 慣性スクロールが完了したか */
            start    : false,
            fb       : false,
            disallow : false,
        }

        this.param = param;
        this.pageID = pageID;

    }
    init(){
        if (this.param.browserType !== 'IE') {
            TweenMax.set(this.$root, { willChange: 'opacity, transform' })
        }

        if(!this.inertia){
            document.body.classList.add('is-inertia-none');
            (function(d, s, id) {
                var js, fjs = d.getElementsByTagName(s)[0];
                if (d.getElementById(id)) return;
                js = d.createElement(s); js.id = id;
                js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.5";
                fjs.parentNode.insertBefore(js, fjs);
            }(document, 'script', 'facebook-jssdk'));
        }

        let _pagetop = document.getElementById('c-pagetop');
        _pagetop.onclick = function() {
            TweenLite.to(window, 1, {scrollTo:{y: 0,autoKill:false}});
        };
        let _footerpagetop = document.getElementById('l-footer-pagetop');
        _footerpagetop.onclick = function() {
            TweenLite.to(window, 1, {scrollTo:{y: 0,autoKill:false}});
        };

    }
    update(inc,dir){ /* スクロール方向を決めうちしないならdirは空で渡してください */
        if (this.status.disallow) {
            this.disallowedInc = inc
            return
        }

        this.inc = inc;
        this.dir = (dir==="")?(this.inc>this.prevInc)?"next":"prev":dir;
        this.status.comp = false;
    }
    updateNoAnimate(inc){
        if (this.status.disallow) {
            this.disallowedInc = inc
            return
        }

        this.inc = this.nowInc = this.prevInc = inc;
        this.status.comp = false;

        this.trans();
    }
    move() {
        if (!this.status.start) return

        let add = 0.09;

        this.nowInc += add * (this.inc - this.nowInc);
        this.sighedDiffInc = this.nowInc - this.prevInc
        this.diffInc = Math.abs(this.sighedDiffInc);

        this.trans();

    }
    trans() {

        if(!scrollAnimation) return;

        if(this.inertia){
            this.$root.style.transform = 'translate3d(' + 0 + ',-' + this.nowInc + 'px ,' + 0 + ')';
            /* スクロール連動で動作 */
            pararax.check(this.nowInc,this.h,this.param);
        }

        /* アニメーション対象の要素があるかチェック */
        scrollAnimation.check(this.nowInc,this.h);

        if(this.diffInc < 0.1){
            this.onComplete();
        }
        this.prevInc = this.nowInc;

        if(this.nowInc >= this.$rootLoad.clientHeight - this.h - 500){
            if(!this.status.comp && !this.status.fb && this.inertia){
                this.status.fb = true;
                (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (d.getElementById(id)) return;
                    js = d.createElement(s); js.id = id;
                    js.src = "//connect.facebook.net/ja_JP/sdk.js#xfbml=1&version=v2.5";
                    fjs.parentNode.insertBefore(js, fjs);
                }(document, 'script', 'facebook-jssdk'));
            }
        }

    }

    resize (_w,_h) {

        if(!scrollAnimation) return;
        this.w = _w;
        if(this.$root.classList.contains('is-modal-open')) return;
        if(this.inertia){
            document.body.style.height = this.$rootLoad.clientHeight + 'px';
        }

        pararax.resize(_h);
        scrollAnimation.resize(_h);

        if(this.pageID === "magnettrivet" || this.pageID === "hk_and_ph" || this.pageID === "apron_and_cloth" && this.param.userAgent === "pc"){
            scrollAnimation.resize(_w);
        }

    }

    /* -------------------------------------------

      -- Callback

    ------------------------------------------- */

    onComplete(){ /* スクロール動作が終わったら */
        if(this.status.comp) return;
        this.status.comp = true;

        if(this.param.userAgent === 'sp' || this.param.userAgent === 'tablet' || this.param.browserType === 'IE' || this.param.browserType === 'safari') return;

        //body用
        this.bodyMatrix = this.$root.style.transform;
        this.bodyMatrix = this.translate(this.bodyMatrix);
        this.$root.style.transform = 'translate3d(' + 0 + ',' + this.bodyMatrix + 'px ,' + 0 + ')';

        if (this.status.disallow) {
            this.inc = this.nowInc = this.disallowedInc = this.stopPositionY
        }
    }

    translate(translate){
        let re = /translate3d\((.*)\)/;
        let vals = translate.match(re)[1].replace(/ /g, "").split(",");
        return parseInt(vals[1]);
    }

    matrix2d(matrix3d){
        var re = /matrix\((.*)\)/;
        if(matrix3d === 'none') return;
        var vals = matrix3d.match(re)[1].replace(/ /g, "").split(",");
        vals = vals.map(Number)
        var matrix = [new Array(4),new Array(4),new Array(4),new Array(4)];

        matrix[0][0] = vals[0];
        matrix[0][1] = vals[1];
        matrix[0][2] = 0;
        matrix[0][3] = 0;
        matrix[1][0] = vals[2];
        matrix[1][1] = vals[3];
        matrix[1][2] = 0;
        matrix[1][3] = 0;
        matrix[2][0] = 0;
        matrix[2][1] = 0;
        matrix[2][2] = 1;
        matrix[2][3] = 0;
        matrix[3][0] = vals[4];
        matrix[3][1] = vals[5];
        matrix[3][2] = 0;
        matrix[3][3] = 1;

        return matrix;
    }

    disallow(stopPositionY) {
        if (typeof stopPositionY !== 'undefined') {
            this.stopPositionY = stopPositionY
            this.update(stopPositionY)
        }
        this.status.disallow = true
        document.addEventListener('mousewheel', this.disallowScroll, { passive: false })
        document.addEventListener('touchmove', this.disallowScroll, { passive: false })
    }

    allow() {
        this.status.disallow = false
        this.update(this.disallowedInc)
        document.removeEventListener('mousewheel', this.disallowScroll, { passive: false })
        document.removeEventListener('touchmove', this.disallowScroll, { passive: false })
    }

    disallowScroll(event) {
        event.preventDefault();
    }

}
